module.exports = __webpack_public_path__ + "img/rohit.ce0c8cd4.png";